import { api } from "./api";

// Schemes admin / engine surface — every endpoint declared in
// docs/schemes-system.md §10. The response envelope is the standard
// { status, message, code, data } returned by the backend.

export const schemeListApi = (params = {}) => api.get(`/schemes`, { params });

export const schemeGetApi = (params) =>
  api.get(`/schemes/${encodeURIComponent(params.id)}`);

export const schemeCreateApi = (params) =>
  api.post(`/schemes`, JSON.stringify(params));

export const schemeUpdateApi = (params) =>
  api.put(`/schemes/${encodeURIComponent(params.id)}`, JSON.stringify(params.body || params));

export const schemePauseApi = (params) =>
  api.post(`/schemes/${encodeURIComponent(params.id)}/pause`, JSON.stringify(params.body || {}));

export const schemeResumeApi = (params) =>
  api.post(`/schemes/${encodeURIComponent(params.id)}/resume`, JSON.stringify(params.body || {}));

export const schemeArchiveApi = (params) =>
  api.post(`/schemes/${encodeURIComponent(params.id)}/archive`, JSON.stringify(params.body || {}));

// Bulk priority re-rank — body shape: { order: [{ id, priority }, ...] }
export const schemeReorderApi = (params) =>
  api.post(`/schemes/reorder`, JSON.stringify(params));

// POS-facing preview — given a bill + customer returns applicable schemes.
export const schemeEvaluateApi = (params) =>
  api.post(`/schemes/evaluate`, JSON.stringify(params));
